// coffeelint: disable
angular.module('gym.membership-plans').factory('MembershipPlanCategory', ["Model", function(Model) {
  var MembershipPlanCategory;
  return MembershipPlanCategory = (function() {
    class MembershipPlanCategory extends Model {
      label() {
        return this.attributes.label;
      }

    };

    MembershipPlanCategory.param = 'membership_plan_category';

    return MembershipPlanCategory;

  }).call(this);
}]);

// coffeelint: enable
